/*
 *
 * CostsDebitDetailsDownloadModal
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 20-Aug-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import CostsDebitDetailsDownloadModal from './CostsDebitDetailsDownloadModal'
import { nullSafe } from 'Utility/globalMethods'
import * as CostsActions from '../../routes/Costs/modules/CostsActions'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(CostsActions, dispatch)
})

const mapStateToProps = (state) => ({
  title: nullSafe(() => state.popup.popupInfo.title, ''),
  subtitle: nullSafe(() => state.popup.popupInfo.subtitle, ''),
  description: nullSafe(() => state.popup.popupInfo.description, ''),
  children: nullSafe(() => state.popup.popupInfo.children, null),
  onClose: nullSafe(() => state.popup.popupInfo.onClose, () => { }),
  primaryButtonLabel: nullSafe(() => state.popup.popupInfo.primaryButtonLabel, ''),
  isDownloadLoading: nullSafe(() => state.loading.localLoading.get_start_download_debit_details, false),
  secondaryButtonLabel: nullSafe(() => state.popup.popupInfo.secondaryButtonLabel, ''),
  typeTabDownload: nullSafe(() => state.popup.popupInfo.typeTabDownload, ''),
  filters: nullSafe(() => state.popup.popupInfo.filters, {}),
  asyncDownload: nullSafe(() => state.popup.popupInfo.asyncDownload, () => { }),
  formatInfoMessage: nullSafe(() => state.popup.popupInfo.formatInfoMessage, '')
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(CostsDebitDetailsDownloadModal)
